import { api } from 'shared/api'
import { AiFlowGeneratorSchemas } from 'shared/api/requests/aiFlowGenerator/schemas'

export const AiFlowGeneratorApi = {
  startChat: api.account.createPost({
    url: '/aiFlowGenerator/startChat',
    schemas: AiFlowGeneratorSchemas.startChat,
    scope: 'ai',
    section: 'ai_flow_generator',
  }),
  sendChatEvent: api.account.createPost({
    url: '/aiFlowGenerator/chatEvent',
    schemas: AiFlowGeneratorSchemas.sendChatEvent,
    scope: 'ai',
    section: 'ai_flow_generator',
  }),
  getFlowDraft: api.account.createPost({
    url: '/aiFlowGenerator/getFlowDraft',
    schemas: AiFlowGeneratorSchemas.getFlowDraft,
    scope: 'ai',
    section: 'ai_flow_generator',
  }),
  applyFlow: api.account.createPost({
    url: '/aiFlowGenerator/applyFlow',
    schemas: AiFlowGeneratorSchemas.applyFlow,
    scope: 'ai',
    section: 'ai_flow_generator',
  }),
}
